import { useRef } from 'react';
import { useNavigate } from 'react-router-dom';

import { PageTitle, SearchInput } from 'components';

export function SearchSection() {
  const inputRef = useRef<HTMLInputElement>(null);
  const navigate = useNavigate();

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    const searchValue = inputRef.current?.value.trim();

    if (searchValue) {
      navigate(`/devolucoes-e-estornos/${searchValue}`);
    }
  };

  return (
    <div className="flex flex-col justify-start items-start max-w-[725px] gap-6 w-full">
      <PageTitle
        title="Devoluções e estornos"
        subtitle="Pesquise pelo número do pedido ou ID para realizar estorno de um pedido específico"
      />

      <SearchInput
        label="N.º do pedido ou ID"
        onSubmit={handleSubmit}
        inputId="search-input"
        inputName="search-input"
        ref={inputRef}
      />
    </div>
  );
}
